import { Notyf } from 'notyf';
import '@molsoft-io/multilingual-module';
import 'notyf/notyf.min.css';
import '../utils/lazy-resources';
import { formatMoney } from '@shopify/theme-currency';

import {
  initiateBreakpoinListener
} from '../utils/breakpoints';

Shopify.formatMoney = formatMoney;

initiateBreakpoinListener();

// Toast notifications
window.toast = new Notyf({
  ripple: false,
  position: {
    x: 'right',
    y: 'bottom'
  },
  dismissible: true,
  duration: 5000
});

// add header height to css variable on scroll
window.addEventListener('scroll', () => {
  const header = document.querySelector('.header');
  const headerHeight = header.offsetHeight;
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
});
